// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
let nextInstanceId = 0;
const AddComment = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
  const instanceId = React.useState(() => `AddComment-${++nextInstanceId}`)[0];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 18}
      height={size ?? 18}
      fill="none"
      viewBox="0 0 18 18"
      ref={ref}
      {...props}
    >
      <mask id={`${instanceId}-AddComment_a`} fill="#fff">
        <path
          fillRule="evenodd"
          d="M4 4a1 1 0 0 0-1 1v9.87a.5.5 0 0 0 .836.37L6.3 13H14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
          clipRule="evenodd"
        />
      </mask>
      <path
        fill="currentColor"
        d="m3.836 15.24-.672-.74zM6.3 13v-1h-.387l-.286.26zM3 5h1V3a2 2 0 0 0-2 2zm0 4.398h1V5H2v4.398zM3 12h1V9.398H2V12zm0 2.87h1V12H2v2.87zm.836.37-.672-.74a.5.5 0 0 1 .836.37H2c0 1.302 1.545 1.986 2.509 1.11zM6.3 13l-.673-.74-2.463 2.24.672.74.673.74 2.464-2.24zm7.7 0v-1H6.3v2H14zm1-1h-1v2a2 2 0 0 0 2-2zm0-7h-1v7h2V5zm-1-1v1h2a2 2 0 0 0-2-2zM4 4v1h10V3H4z"
        mask={`url(#${instanceId}-AddComment_a)`}
      />
      <path stroke="currentColor" strokeLinejoin="round" d="M9 6.5v4M7 8.5h4" />
    </svg>
  );
};
const ForwardRef = forwardRef(AddComment);
export default ForwardRef;
